// Sanitize user input to prevent XSS and injection
export default function sanitizeInput(str) {
  if (typeof str !== "string") return "";
  return str
    .replace(/<\/?(script|style)[^>]*>/gi, "")
    .replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]))
    .trim();
}
